import {Component, Input} from '@angular/core';

@Component({
  selector: 'app-specifications',
  templateUrl: './specifications.component.html',
  styleUrls: ['./specifications.component.css']
})
export class SpecificationsComponent {
  @Input() specifications: any[];
  @Input() otherSpecifications: any;
  productImage =
     [
        { name: 'Image 1', imgurl:  'https://api-media.makingdatameaningful.com/files/gsm/12549/samsung_galaxy-s24_2024_1.jpeg' },
        { name: 'Image 2', imgurl:  'https://api-media.makingdatameaningful.com/files/gsm/12549/samsung_galaxy-s24_2024_3.webp'},
        { name: 'Image 4', imgurl: 'https://api-media.makingdatameaningful.com/files/gsm/12549/samsung_galaxy-s24_2024_5.jpeg' },
        { name: 'Image 5', imgurl:  'https://api-media.makingdatameaningful.com/files/gsm/12549/samsung_galaxy-s24_2024_6.webp' },
        { name: 'Image 6', imgurl: 'https://api-media.makingdatameaningful.com/files/gsm/12549/samsung_galaxy-s24_2024_7.jpeg' },
        { name: 'Image 7', imgurl:  'https://api-media.makingdatameaningful.com/files/gsm/12549/samsung_galaxy-s24_2024_8.webp' },
      ];
}
